// extracted by mini-css-extract-plugin
export default {"ribbon":"ribon_ribbon__TXQ-W"};